module.exports = __webpack_public_path__ + "images/saaremaa/ms-icon-70x70.png";